(function () {
  const PRODUCT_SCENT_MAP = {
    // Scalp Shampoo
    "refreshing-scalp-shampoo-green-breeze-500ml": {
      "Green Breeze": "/products/refreshing-scalp-shampoo-green-breeze-500ml?variant=40582740246714",
      "Wild Flower": "/products/refreshing-scalp-shampoo-wild-flower-500ml?variant=45540340727994"
    },
    "refreshing-scalp-shampoo-wild-flower-500ml": {
      "Green Breeze": "/products/refreshing-scalp-shampoo-green-breeze-500ml?variant=40582740246714",
      "Wild Flower": "/products/refreshing-scalp-shampoo-wild-flower-500ml?variant=45540340727994"
    },

    // Protein Booster
    "protein-booster-hair-treatment-green-breeze": {
      "Green Breeze": "/products/protein-booster-hair-treatment-green-breeze?variant=45540191862970",
      "Wild Flower": "/products/21412?variant=45540325130426"
    },
    "21412": {
      "Green Breeze": "/products/protein-booster-hair-treatment-green-breeze?variant=45540191862970",
      "Wild Flower": "/products/21412?variant=45540325130426"
    },
    "promotion-set-2-scalp-green": {
    "Green Breeze": "/products/promotion-set-2-scalp-green?variant=40465144250554",
    "Wild Flower": "/products/promotion-set-2-scalp-wild?variant=40465148674234"
    },
    "promotion-set-2-scalp-wild": {
    "Green Breeze": "/products/promotion-set-2-scalp-green?variant=40465144250554",
    "Wild Flower": "/products/promotion-set-2-scalp-wild?variant=40465148674234"
    },
  };

  const norm = (v) => (v || "").toString().trim();
  const lower = (v) => norm(v).toLowerCase();

  function getCurrentHandle() {
    const m = window.location.pathname.match(/^\/products\/([^\/]+)/);
    return m ? m[1] : null;
  }

  function resolveKey(candidate, scentMap) {
    const c = norm(candidate);
    if (!c) return null;

    // exact
    if (scentMap[c]) return c;

    // case-insensitive
    const k = Object.keys(scentMap).find(x => lower(x) === lower(c));
    return k || null;
  }

  function shouldIgnoreTarget(el) {
    if (!el || !(el instanceof Element)) return true;

    // ignore add-to-cart / qty buttons etc
    const txt = lower(el.textContent);
    const aria = lower(el.getAttribute("aria-label"));
    const type = lower(el.getAttribute("type"));
    if (type === "submit") return true;
    if (txt.includes("add to cart") || aria.includes("add to cart")) return true;
    return false;
  }

  function getScentMapForThisPage() {
    const handle = getCurrentHandle();
    if (!handle) return null;
    return PRODUCT_SCENT_MAP[handle] || null;
  }

  // ✅ 한 번만 이동하게(중복 change/click 방지)
  let redirecting = false;
  function go(url) {
    if (!url || redirecting) return;
    redirecting = true;
    window.location.href = url;
  }

  function handleSelectChange(target) {
    const scentMap = getScentMapForThisPage();
    if (!scentMap) return;

    const sel = target;
    const opt = sel.options?.[sel.selectedIndex];
    const key = resolveKey(sel.value, scentMap) || resolveKey(opt?.text, scentMap);
    const url = key ? scentMap[key] : null;
    if (url) go(url);
  }

  function handleRadioChange(target) {
    const scentMap = getScentMapForThisPage();
    if (!scentMap) return;

    const radio = target;
    if (!radio.checked) return;

    // ✅ 테마가 연결 URL을 여기 넣는 경우가 있어서 우선순위 1
    const connected = norm(radio.dataset.connectedProductUrl);
    if (connected) {
      go(connected);
      return;
    }

    const key = resolveKey(radio.value, scentMap) || resolveKey(radio.getAttribute("aria-label"), scentMap);
    const url = key ? scentMap[key] : null;
    if (url) go(url);
  }

  // label 클릭(버튼처럼 보이는 UI)은 라디오가 바뀌기 전에 click이 먼저 올 때가 있어서,
  // click에서도 "라디오 추정"을 한 번 더 처리해줌.
  function handleClick(target) {
    if (shouldIgnoreTarget(target)) return;

    const scentMap = getScentMapForThisPage();
    if (!scentMap) return;

    // 1) label -> for로 연결된 radio 찾기
    const label = target.closest("label");
    if (label) {
      const forId = label.getAttribute("for");
      if (forId) {
        const input = label.ownerDocument.getElementById(forId);
        if (input && input.matches('input[type="radio"]')) {
          // click 직후 checked가 아직 아닐 수 있어서 살짝 지연
          setTimeout(() => handleRadioChange(input), 0);
          return;
        }
      }
      // label 안에 radio가 있는 경우
      const innerRadio = label.querySelector('input[type="radio"]');
      if (innerRadio) {
        setTimeout(() => handleRadioChange(innerRadio), 0);
        return;
      }
    }

    // 2) role=button/button/div 등에서 텍스트가 향 이름이면 이동
    const text = norm(target.getAttribute("data-scent")) ||
                 norm(target.getAttribute("data-value")) ||
                 norm(target.getAttribute("data-option-value")) ||
                 norm(target.getAttribute("aria-label")) ||
                 norm(target.textContent);

    const key = resolveKey(text, scentMap);
    const url = key ? scentMap[key] : null;
    if (url) {
      // 폼 submit 막고 이동
      try { target.closest("form") && event.preventDefault(); } catch(e) {}
      go(url);
    }
  }

  function install(doc) {
    if (!doc || doc.__scentRedirectInstalled) return;
    doc.__scentRedirectInstalled = true;

    // ✅ change를 캡처링으로 걸어두면 테마가 stopPropagation 해도 웬만하면 잡힘
    doc.addEventListener("change", (e) => {
      const t = e.target;
      if (!(t instanceof Element)) return;

      if (t.matches("select")) {
        handleSelectChange(t);
        return;
      }
      if (t.matches('input[type="radio"]')) {
        handleRadioChange(t);
        return;
      }
    }, true);

    // ✅ 클릭도 같이(라벨/버튼 UI 대응)
    doc.addEventListener("click", (e) => {
      const t = e.target;
      if (!(t instanceof Element)) return;
      handleClick(t);
    }, true);

    // ✅ AJAX로 옵션 UI가 다시 렌더되는 테마 대비: observer로도 안전망
    const obs = new MutationObserver(() => {
      // 현재 페이지 핸들에 해당하는 scentMap이 있으면 redirecting 리셋(페이지 이동 전이라도)
      // (여기서는 별도 작업 필요 없음. 위임 리스너가 이미 잡음)
    });
    obs.observe(doc.documentElement || doc.body, { childList: true, subtree: true });
  }

  function tryInstall() {
    install(document);

    const iframe = document.getElementById("storefront-iframe-1");
    if (!iframe) return;

    const bindFrame = () => {
      try {
        const doc = iframe.contentDocument || iframe.contentWindow?.document;
        if (!doc) return;
        install(doc);
      } catch (e) {}
    };

    if (iframe.contentDocument?.readyState === "complete") bindFrame();
    else iframe.addEventListener("load", bindFrame, { once: true });

    setTimeout(bindFrame, 300);
    setTimeout(bindFrame, 1200);
  }

  document.addEventListener("DOMContentLoaded", tryInstall);
  document.addEventListener("shopify:section:load", tryInstall);
})();